export interface TimelineProps {
  year: number;
  desc: string;
}

export const timelines: Array<TimelineProps> = [
  {
    year: 2000,
    desc: 'Perubahan Management dan Kepemilikan',
  },
  {
    year: 2007,
    desc: 'Menggunakan ‘Remote Trading’',
  },
  {
    year: 2009,
    desc: 'Berpartisipasi dalam Transaksi Negosiasi PT Adaro Energy senilai Rp15,73 Triliun',
  },
  {
    year: 2021,
    desc: 'Terdaftar di KSEI dan IDX sebagai sekuritas yang dapat melakukan pembukaan rekening efek secara digital ',
  },
  {
    year: 2021,
    desc: 'Perubahan Manajemen & Kepemilikian dari PT Mahakarya Artha Sekuritas menjadi PT Stockbit Sekuritas Digital ',
  },
];

export interface ManagementProps {
  name: string;
  position: string;
  desc: string;
}

export const managements: Array<ManagementProps> = [
  {
    name: 'Bacelius Ruru',
    position: 'Komisaris Utama & Independen',
    desc: 'Menjabat resmi sebagai Komisaris Utama dan Independen PT Stockbit Sekuritas Digital sejak tahun 2021, beliau meniti karir pada Departemen Keuangan dan menduduki sejumlah jabatan penting di lingkungan Departemen Keuangan dan Kementerian BUMN, antara lain Ketua Badan Pengawas Pasar Modal ‘Bapepam’(1993-1995) selanjutnya, menjadi Komisaris Utama PT Bursa Efek Indonesia periode 2001-2008.',
  },
  {
    name: 'Wellson Lo',
    position: 'Komisaris',
    desc: 'Menjabat resmi sebagai Komisaris PT. Stockbit Sekuritas Digital sejak tahun 2022, beliau merupakan Lulusan Bachelor of Accounting and Finance dari University of Melbourne dan Master in Finance dari Monash University dimana memiliki pengalaman  selama 4 tahun dalam bidang audit, analis saham dan financial controller di Singapura dan Jakarta.',
  },
  {
    name: 'Megawati Andrew Soewardi',
    position: 'Direktur Utama',
    desc: 'Menjabat resmi sebagai Direktur Utama PT. Stockbit Sekuritas Digital, beliau mengawali karirnya di Industri Pasar Modal sejak tahun 1997. Pada tahun 2012, beliau diangkat menjadi Direktur Utama PT. Mahakarya Artha Securities hingga perusahaan berganti nama sekarang menjadi PT Stockbit Sekuritas Digital.',
  },
  {
    name: 'Jason Terence Halim',
    position: 'Direktur',
    desc: 'Menjabat resmi sebagai Direktur PT. Stockbit Sekuritas Digital, beliau mengawali karirnya di Industri Pasar Modal sejak tahun 2007. Pada tahun 2011, beliau diangkat menjadi Direktur PT. Mahakarya Artha Securities hingga perusahaan berganti nama menjadi PT Stockbit Sekuritas Digital.',
  },
  {
    name: 'Jana Lukito',
    position: 'Direktur',
    desc: 'Menjabat resmi sebagai Direktur PT. Stockbit Sekuritas Digital, beliau memiliki latar belakang keuangan dan mengawali karirnya di Industri Pasar Modal sejak tahun 2001. Beliau juga diangkat menjadi Direktur PT. Mahakarya Artha Securities sejak tahun 2001 hingga sekarang dimana perusahaan berganti nama menjadi PT Stockbit Sekuritas Digital.',
  },
];

export interface ManagementPropsFunction extends ManagementProps {
  showDesc: boolean;
}

export interface LicenseHolderProps {
  name: string;
  position: string;
  count: number;
}

export const licenseHolder: Array<LicenseHolderProps> = [
  {
    name: 'Dewan Komisaris',
    position: 'Pemegang Lisensi  WPPE OJK',
    count: 1,
  },
  {
    name: 'Direksi',
    position: 'Pemegang Lisensi  WPPE OJK',
    count: 3,
  },
  {
    name: 'Karyawan',
    position: 'Pemegang Lisensi  WPPE OJK',
    count: 18,
  },
  {
    name: 'Karyawan',
    position: 'Pemegang Lisensi  WPEE OJK',
    count: 1,
  },
];
